// Generated by web/build.mjs: the settings sheet and its menu, from their own file next to the script,
// with the menu's texts in the language in use (a menu without them is English).
import { loadPart } from './designs.js';
import { loadMenuTexts } from './languages.js';
export const loadMenu = async () => (await Promise.all([loadPart('menu'), loadMenuTexts().catch(() => {})]))[0];